﻿import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { ApplicationProgressService } from '../../../../shared/services/application-progress.service';
import { MixpanelService } from '../../../../shared/services/mixpanel.service';
import { ConfigKey, ConfigurationService } from '../../../../shared/services/configuration/configuration.service';
import { SessionStorageService } from '../../../../shared/services/session/shared/session/session-storage/session-storage.service';

@Injectable()
export class PLApplicationProgressService extends ApplicationProgressService {
  private _hasRegistered: boolean = false;
  private _hasSelectedOffer: boolean = false;
  private _hasApplied: boolean = false;

  public isStepperHidden: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public hasSelectedOfferChange: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(
    public mixpanelService: MixpanelService,
    private configService: ConfigurationService) {
    super(mixpanelService);
    this.populateFromSessionStorage();
  }

  private saveSession(): void {
    SessionStorageService.savePersonalLoanApplicationProgressData(
      this._hasRegistered,
      this._hasSelectedOffer,
      this._hasApplied
    );
  }

  public get hasRegistered(): boolean {
    return this._hasRegistered;
  }

  public get hasSelectedOffer(): boolean {
    return this._hasSelectedOffer;
  }

  public get hasApplied(): boolean {
    return this._hasApplied;
  }

  public markUnregistered(): void {
    this._hasRegistered = false;
  }

  public markRegistered(): void {
    this._hasRegistered = true;
  }

  public selectOffer(): void {
    if (!this._hasSelectedOffer) {
      this._hasSelectedOffer = true;
      this.saveSession();
      this.hasSelectedOfferChange.next(true);
    }
  }

  public unselectOffer(): void {
    this._hasSelectedOffer = false;
    this.saveSession();
    this.hasSelectedOfferChange.next(false);
  }

  public submitApplication(): void {
    this._hasApplied = true;
    this.saveSession();
  }

  public logAnalytics(eventName: string, definition: string, properties?: Object, callback?: Function): void {
    let analyticsObject: any = properties || {};
    analyticsObject.Definition = definition;
    analyticsObject.Product = 'P';
    analyticsObject.User = 'B';
    analyticsObject.Experience = 'O';

    this.mixpanelService.track(eventName, analyticsObject, callback);
  }

  public errorAnalytics(h1?: string, response?: any, errorCode?: number) {
    this.trackError('P', errorCode, h1, response);
  }

  public aliasAnalytics(alias: string): void {
    this.mixpanelService.alias(alias);
    setTimeout(() => {
      this.mixpanelService.alias( btoa(alias) );
    }, 200);
  }

  public identifyAnalytics(identify: string): void {
    this.mixpanelService.identify( btoa(identify) );
  }

  public peopleInfoAnalytics(info: any): void {
    this.mixpanelService.peopleSet(info);
  }

  public reset(): void {
    this._hasRegistered = false;
    this._hasSelectedOffer = false;
    this.hasSelectedOfferChange.next(false);
    this._hasApplied = false;
    this.saveSession();
  }

  private populateFromSessionStorage(): void {
    const data = SessionStorageService.getPersonalLoanApplicationProgressData();

    if (data) {
      this._hasRegistered = data.hasRegistered;
      this._hasSelectedOffer = data.hasSelectedOffer;
      this.hasSelectedOfferChange.next(data.hasSelectedOffer);
      this._hasApplied = data.hasApplied;
    }
  }
}
